import { render } from "./CustomersReporting.vue?vue&type=template&id=16a7eada&scoped=true"
import script from "./CustomersReporting.vue?vue&type=script&lang=js"
export * from "./CustomersReporting.vue?vue&type=script&lang=js"

import "./CustomersReporting.vue?vue&type=style&index=0&id=16a7eada&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a7eada"]])

export default __exports__